import { createFileRoute } from "@tanstack/react-router";
import PageLayout from "@/components/layout/PageLayout";
import Dashboard from "@/components/ui/Dashboard";
import AdminSidebar from "@/components/layout/AdminSidebar";
import ProtectedRoute from "@/components/auth/ProtectedRoute";

export const Route = createFileRoute("/_protected/dashboard")({
	component: () => (
		<ProtectedRoute>
			<PageLayout>
				<div className="flex h-screen">
					<AdminSidebar />
					<main className="flex-1 overflow-auto">
						<Dashboard />
					</main>
				</div>
			</PageLayout>
		</ProtectedRoute>
	),
});
